import { usePromotions } from "../context/PromotionContext";
import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { LiaArrowRightSolid } from "react-icons/lia";
import {
  FaGift,
  FaHeadset,
  FaShieldAlt,
  FaTruck,
  FaYoutube,
} from "react-icons/fa";
import DiscountedProductCard from "../components/DiscountedProductCard";
import HomeSection from "../components/home/HomeSection";
import PromoModal from "../components/home/PromoModal";
import {
  isProductInStock,
  sortProductsByAvailability,
} from "../utils/productAvailability";
import { getProductDiscountPercent } from "../utils/productSorting";
import {
  getBrandFallbackText,
  getBrandPath,
} from "../config/brands";
import { getPublicBrands } from "../api/brandsApi";
import { PROMOTIONS_PATH } from "../config/navigation";
import styles from "./Home.module.css";

const VIDEO_CATEGORIES = [
  "Усі",
  "Собаки",
  "Коти",
  "Здоров'я",
  "Догляд",
  "Харчування",
  "Адаптація",
];

const HERO_BENEFITS = [
  {
    title: "Перевірена якість",
    text: "Тільки надійні бренди",
    Icon: FaShieldAlt,
  },
  {
    title: "Швидка доставка",
    text: "По всій Україні",
    Icon: FaTruck,
  },
  {
    title: "Дбайлива підтримка",
    text: "Ми завжди поруч",
    Icon: FaHeadset,
  },
  {
    title: "Акційні пропозиції та знижки",
    text: "Вигідно постійно",
    Icon: FaGift,
  },
];

const PET_VIDEOS = [
  {
    id: "Q4RidyLdvTc",
    title: "Щеня в будинку. Важливі правила догляду за цуценятами",
    category: "Собаки",
    thumbnail: "https://img.youtube.com/vi/Q4RidyLdvTc/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=Q4RidyLdvTc",
  },
  {
    id: "KHjwUEyMf9I",
    title:
      "Коти. Все, що варто знати про котів. Що придбати, як доглядати, чим годувати?",
    category: "Коти",
    thumbnail: "https://img.youtube.com/vi/KHjwUEyMf9I/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=KHjwUEyMf9I",
  },
  {
    id: "eDqyGW27KmU",
    title:
      "Вакцинація домашніх улюбленців: навіщо, як часто, чи варто хвилюватися",
    category: "Здоров'я",
    thumbnail: "https://img.youtube.com/vi/eDqyGW27KmU/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=eDqyGW27KmU",
  },
  {
    id: "wJcg-hYHH-4",
    title: "Як правильно доглядати за домашніми улюбленцями",
    category: "Догляд",
    thumbnail: "https://img.youtube.com/vi/wJcg-hYHH-4/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=wJcg-hYHH-4",
  },
  {
    id: "dlWJ2b-FirY",
    title: "Чим і як годувати цуценят? Поради від ветеринарного лікаря",
    category: "Харчування",
    thumbnail: "https://img.youtube.com/vi/dlWJ2b-FirY/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=dlWJ2b-FirY",
  },
  {
    id: "Mlla30LNSAs",
    title: "Перші пів року з улюбленцем: адаптація, навчання, турбота",
    category: "Адаптація",
    thumbnail: "https://img.youtube.com/vi/Mlla30LNSAs/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=Mlla30LNSAs",
  },
  {
    id: "nOt5fucJyrE",
    title: "Догляд за собаками породи той-тер'єр",
    category: "Собаки",
    thumbnail: "https://img.youtube.com/vi/nOt5fucJyrE/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=nOt5fucJyrE",
  },
  {
    id: "vj772MC-jYQ",
    title: "Як вибрати кошеня: правильний вибір породи кошенят",
    category: "Коти",
    thumbnail: "https://img.youtube.com/vi/vj772MC-jYQ/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=vj772MC-jYQ",
  },
  {
    id: "5F9KnmmZcfk",
    title: "Обробка від паразитів. Як захистити улюбленця",
    category: "Здоров'я",
    thumbnail: "https://img.youtube.com/vi/5F9KnmmZcfk/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=5F9KnmmZcfk",
  },
  {
    id: "8rRL5G9l0xI",
    title: "Як доглядати за домашніми улюбленцями восени",
    category: "Догляд",
    thumbnail: "https://img.youtube.com/vi/8rRL5G9l0xI/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=8rRL5G9l0xI",
  },
  {
    id: "CsxCK6RJr7Y",
    title: "Коти та собаки. Як правильно розрахувати добову порцію корму",
    category: "Харчування",
    thumbnail: "https://img.youtube.com/vi/CsxCK6RJr7Y/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=CsxCK6RJr7Y",
  },
  {
    id: "ba9ZxVdMxMg",
    title: "Що купити коту перед його появою в сім'ї",
    category: "Адаптація",
    thumbnail: "https://img.youtube.com/vi/ba9ZxVdMxMg/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=ba9ZxVdMxMg",
  },
  {
    id: "Ru9nD1bgyiA",
    title: "Стерилізація і кастрація: плюси, мінуси та підводні камені",
    category: "Здоров'я",
    thumbnail: "https://img.youtube.com/vi/Ru9nD1bgyiA/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=Ru9nD1bgyiA",
  },
  {
    id: "nZ7nAZRJyAE",
    title: "Мейн-кун: все про величних котів! Характер, поведінка, догляд",
    category: "Коти",
    thumbnail: "https://img.youtube.com/vi/nZ7nAZRJyAE/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=nZ7nAZRJyAE",
  },
  {
    id: "XpOYg5DaYDk",
    title: "Відповіді на ваші питання від ветеринарних лікарів",
    category: "Здоров'я",
    thumbnail: "https://img.youtube.com/vi/XpOYg5DaYDk/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=XpOYg5DaYDk",
  },
  {
    id: "b7gtLTOkazQ",
    title: "Як доглядати за котиком. Від купання до вичісування",
    category: "Догляд",
    thumbnail: "https://img.youtube.com/vi/b7gtLTOkazQ/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=b7gtLTOkazQ",
  },
  {
    id: "VPa8Zg7g_pM",
    title: "Улюбленець погано їсть. Що з цим робити",
    category: "Харчування",
    thumbnail: "https://img.youtube.com/vi/VPa8Zg7g_pM/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=VPa8Zg7g_pM",
  },
  {
    id: "eUHM0V-Z-FU",
    title: "Як привчити кошеня ходити в лоток",
    category: "Адаптація",
    thumbnail: "https://img.youtube.com/vi/eUHM0V-Z-FU/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=eUHM0V-Z-FU",
  },
  {
    id: "aWXON51xZBs",
    title: "Кішки – важливі щеплення",
    category: "Здоров'я",
    thumbnail: "https://img.youtube.com/vi/aWXON51xZBs/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=aWXON51xZBs",
  },
  {
    id: "dhUsns1fC0U",
    title: "Обстеж кота від носа до хвоста",
    category: "Коти",
    thumbnail: "https://img.youtube.com/vi/dhUsns1fC0U/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=dhUsns1fC0U",
  },
  {
    id: "VIiaC5fc9qs",
    title: "Післяопераційний догляд за твариною: що можна, а чого не можна",
    category: "Догляд",
    thumbnail: "https://img.youtube.com/vi/VIiaC5fc9qs/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=VIiaC5fc9qs",
  },
  {
    id: "ruuz1E7JCMU",
    title: "Як часто потрібно годувати кошенят",
    category: "Харчування",
    thumbnail: "https://img.youtube.com/vi/ruuz1E7JCMU/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=ruuz1E7JCMU",
  },
  {
    id: "1AffZHhKTcA",
    title: "Поведінка кошенят — точити кігті, лазити та ховатися",
    category: "Адаптація",
    thumbnail: "https://img.youtube.com/vi/1AffZHhKTcA/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=1AffZHhKTcA",
  },
  {
    id: "qiCoXME9jX4",
    title: "Навіщо і коли каструвати кота",
    category: "Здоров'я",
    thumbnail: "https://img.youtube.com/vi/qiCoXME9jX4/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=qiCoXME9jX4",
  },
  {
    id: "Y-WhLRvf-40",
    title: "Як зробити коту укол без проблем? Робимо укол підшкірно",
    category: "Здоров'я",
    thumbnail: "https://img.youtube.com/vi/Y-WhLRvf-40/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=Y-WhLRvf-40",
  },
  {
    id: "G4DqY-KkgHg",
    title: "Догляд за шерстю кота: правила та поради",
    category: "Догляд",
    thumbnail: "https://img.youtube.com/vi/G4DqY-KkgHg/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=G4DqY-KkgHg",
  },
  {
    id: "giqqb4Fjx1g",
    title: "Чому котик дряпає меблі? 5 основних причин",
    category: "Коти",
    thumbnail: "https://img.youtube.com/vi/giqqb4Fjx1g/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=giqqb4Fjx1g",
  },
  {
    id: "zBJ2FFVDihI",
    title: "Як доглядати за улюбленцем після кастрації чи стерилізації",
    category: "Догляд",
    thumbnail: "https://img.youtube.com/vi/zBJ2FFVDihI/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=zBJ2FFVDihI",
  },
  {
    id: "qfNbkI96RzQ",
    title: "Як вигулювати кошеня у дворі",
    category: "Адаптація",
    thumbnail: "https://img.youtube.com/vi/qfNbkI96RzQ/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=qfNbkI96RzQ",
  },
  {
    id: "dVTzlZpPhz0",
    title: "Як правильно доглядати за зрілими та літніми котами",
    category: "Коти",
    thumbnail: "https://img.youtube.com/vi/dVTzlZpPhz0/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=dVTzlZpPhz0",
  },
  {
    id: "WoaPt7IV_ws",
    title: "Стерилізація котів та кішок: рекомендації, ризики і догляд",
    category: "Здоров'я",
    thumbnail: "https://img.youtube.com/vi/WoaPt7IV_ws/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=WoaPt7IV_ws",
  },
  {
    id: "sDIah6V964Y",
    title: "Як дати таблетку коту",
    category: "Здоров'я",
    thumbnail: "https://img.youtube.com/vi/sDIah6V964Y/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=sDIah6V964Y",
  },
  {
    id: "EJRvCiENOUA",
    title:
      "Кішки для квартири: яку породу кішок вибрати для квартири та будинку",
    category: "Коти",
    thumbnail: "https://img.youtube.com/vi/EJRvCiENOUA/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=EJRvCiENOUA",
  },
  {
    id: "JWf4hbGYDOU",
    title: "Як вибрати кращу породу кішок для дітей та сім'ї",
    category: "Коти",
    thumbnail: "https://img.youtube.com/vi/JWf4hbGYDOU/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=JWf4hbGYDOU",
  },
];

const getNextVideoIndex = (videos, currentIndex) => {
  if (!videos.length) return 0;

  const currentCategory = videos[currentIndex]?.category;

  for (let step = 1; step < videos.length; step += 1) {
    const nextIndex = (currentIndex + step) % videos.length;
    if (videos[nextIndex].category !== currentCategory) {
      return nextIndex;
    }
  }

  return (currentIndex + 1) % videos.length;
};

const getInitialVideoIndex = (videos) => {
  if (!videos.length) return 0;

  const storageKey = "myZooLastPreviewVideoIndex";
  const lastIndex = Number(localStorage.getItem(storageKey) ?? -1);

  if (lastIndex < 0 || lastIndex >= videos.length) {
    localStorage.setItem(storageKey, "0");
    return 0;
  }

  const nextIndex = getNextVideoIndex(videos, lastIndex);
  localStorage.setItem(storageKey, String(nextIndex));
  return nextIndex;
};

function Home() {
  const navigate = useNavigate();
  const { visible: promotionsVisible, revision: promotionRevision } = usePromotions();
  const [discountedProducts, setDiscountedProducts] = useState([]);
  const [isPromoOpen, setIsPromoOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("Усі");
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [failedBrandLogos, setFailedBrandLogos] = useState({});
  const [brands, setBrands] = useState([]);
  const [brandsLoading, setBrandsLoading] = useState(true);
  const [brandsError, setBrandsError] = useState("");

  useEffect(() => {
    const fetchDiscounted = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/products/discounted`,
        );
        setDiscountedProducts(response.data);
      } catch (error) {
        console.error("Помилка завантаження акційних товарів:", error);
      }
    };

    fetchDiscounted();
  }, [promotionRevision]);

  const fetchBrands = async (signal) => {
    setBrandsLoading(true);
    setBrandsError("");
    try {
      const items = await getPublicBrands({ signal });
      setBrands(items);
    } catch (error) {
      if (error?.name === "CanceledError" || error?.code === "ERR_CANCELED") return;
      console.error("Помилка завантаження брендів:", error);
      setBrandsError("Не вдалося завантажити бренди.");
    } finally {
      if (!signal?.aborted) setBrandsLoading(false);
    }
  };

  useEffect(() => {
    const controller = new AbortController();
    fetchBrands(controller.signal);
    return () => controller.abort();
  }, []);

  useEffect(() => {
    if (!promotionsVisible) return;
    const hasSeenPromo = localStorage.getItem("myZooSeenPromoModal");
    if (hasSeenPromo) {
      return;
    }

    const timer = setTimeout(() => {
      setIsPromoOpen(true);
    }, 1800);

    return () => clearTimeout(timer);
  }, [promotionsVisible]);

  useEffect(() => {
    if (!PET_VIDEOS.length) return;

    const nextIndex = getInitialVideoIndex(PET_VIDEOS);
    setCurrentVideoIndex(nextIndex);
  }, []);

  const discountedItems = useMemo(
    () =>
      sortProductsByAvailability(
        discountedProducts.filter(
          (item) =>
            getProductDiscountPercent(item) > 0 && isProductInStock(item),
        ),
      ),
    [discountedProducts],
  );

  const filteredVideos = useMemo(() => {
  if (selectedCategory === "Усі") return PET_VIDEOS;
  return PET_VIDEOS.filter((video) => video.category === selectedCategory);
  }, [selectedCategory]);

  const currentVideo = filteredVideos[currentVideoIndex] || filteredVideos[0];
  
  useEffect(() => {
  setCurrentVideoIndex(0);
  }, [selectedCategory]); 

  const closePromoModal = () => {
    localStorage.setItem("myZooSeenPromoModal", "1");
    setIsPromoOpen(false);
  };

  const showNextVideo = () => {
    if (!filteredVideos.length) return;

    setCurrentVideoIndex((prev) => (prev + 1) % filteredVideos.length);
  };

  const handleBrandLogoError = (brandValue) => {
    setFailedBrandLogos((prev) => {
      if (prev[brandValue]) return prev;
      return { ...prev, [brandValue]: true };
    });
  };

  return (
    <div className={styles.home}>
      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <p className={styles.heroBadge}>MyZooShop - це турбота щодня!</p>
          <h1>Все для здорового та щасливого життя вашого улюбленця</h1>
          <p>
            Якісний корм, аксесуари та ветеринарно схвалені рішення в одному
            каталозі.
          </p>
          <div className={styles.heroActions}>
            <Link
              className={styles.primaryButton}
              to="/products"
            >
              Перейти до покупок <LiaArrowRightSolid />
            </Link>
            {promotionsVisible && <Link
              className={styles.secondaryButton}
              to={PROMOTIONS_PATH}
            >
              Гарячі знижки 🔥
            </Link>}
          </div>
        </div>
        <div className={styles.heroMedia}>
          <img
            src="https://dl.dropboxusercontent.com/scl/fi/bkk4890f36wpbp4h8d0iz/background.png?rlkey=rgh34v240jamnhzawvrmkt1tj&st=yvlqs3ks&dl=0"
            alt="Щасливий домашній улюбленець"
            loading="lazy"
          />
        </div>
        <div className={styles.heroBenefits} aria-label="Переваги MyZooShop">
          {HERO_BENEFITS.filter((benefit) => benefit.Icon !== FaGift || promotionsVisible).map(({ title, text, Icon }) => (
            <article className={styles.heroBenefitCard} key={title}>
              <span className={styles.heroBenefitIcon} aria-hidden="true">
                <Icon />
              </span>
              <span className={styles.heroBenefitText}>
                <strong>{title}</strong>
                <span>{text}</span>
              </span>
            </article>
          ))}
        </div>
      </section>

      {(brandsLoading || brandsError || brands.length > 0) && (
        <HomeSection
          subtitle="Обирай улюблений бренд в один клік"
          className={styles.brandsSection}
          headingClassName={styles.brandsHeader}
        >
          {brandsLoading ? (
            <div className={styles.brandsGrid} aria-label="Завантаження брендів" aria-busy="true">
              {Array.from({ length: 8 }, (_, index) => (
                <span className={styles.brandSkeleton} key={index} aria-hidden="true" />
              ))}
            </div>
          ) : brandsError ? (
            <div className={styles.brandsState} role="alert">
              <span>{brandsError}</span>
              <button type="button" onClick={() => fetchBrands()}>Спробувати ще раз</button>
            </div>
          ) : (
            <div className={styles.brandsGrid}>
              {brands.map((brand) => (
                <Link
                  to={getBrandPath(brand.catalogSlug || brand.slug)}
                  key={brand.id || brand.slug}
                  className={styles.brandButton}
                  aria-label={`Перейти до товарів бренду ${brand.name}`}
                >
                  {brand.logoUrl && !failedBrandLogos[brand.id || brand.slug] ? (
                    <img
                      src={brand.logoUrl}
                      alt={`Логотип бренду ${brand.name}`}
                      loading="lazy"
                      className={styles.brandLogo}
                      onError={() => handleBrandLogoError(brand.id || brand.slug)}
                    />
                  ) : (
                    <span className={styles.brandFallback} aria-hidden="true">
                      {getBrandFallbackText(brand.name)}
                    </span>
                  )}
                  <span className={styles.brandName}>{brand.name}</span>
                </Link>
              ))}
            </div>
          )}
        </HomeSection>
      )}

      {promotionsVisible && discountedItems.length > 0 && (
        <HomeSection title="Акційні товари">
          <div className={styles.discountedList}>
            {discountedItems.slice(0, 6).map((product) => (
              <DiscountedProductCard key={product._id} product={product} />
            ))}
          </div>
          <Link
            className={styles.viewMoreButton}
            to={PROMOTIONS_PATH}
          >
            Переглянути всі акції та знижки <LiaArrowRightSolid />
          </Link>
        </HomeSection>
      )}

      <HomeSection title="Чому обирають нас?" className={styles.softBackground}>
        <div className={styles.benefitList}>
          <article className={styles.benefitItem}>
            <div className={styles.benefitMedia}>
              <img
                src="https://dl.dropboxusercontent.com/scl/fi/5is16g9s4r593jd5l0qqh/.png?rlkey=darwlv215ghttiywcv7gvyseu&st=q4dpxsgx&dl=0"
                alt="Якість"
                loading="lazy"
              />
              <div className={styles.benefitGradient} />
              <div className={styles.benefitOverlay}>
                <h3>Якість</h3>
                <p>
                  Ми дбаємо про ваших улюбленців так само, як і ви. Саме тому
                  пропонуємо лише ті товари, які обрали б для своїх власних
                  тварин — безпечні, якісні та перевірені часом.
                </p>
              </div>
            </div>
          </article>

          <article className={styles.benefitItem}>
            <div className={styles.benefitMedia}>
              <img
                src="https://dl.dropboxusercontent.com/scl/fi/zcayd4arbobwva2l8rnx4/.png?rlkey=neckvem4qylzyt2m8rhxh8ib1&st=w02971rv&dl=0"
                alt="Швидка доставка"
                loading="lazy"
              />
              <div className={styles.benefitGradient} />
              <div className={styles.benefitOverlay}>
                <h3>Швидка доставка</h3>
                <p>
                  Ми знаємо, як важливо отримати замовлення вчасно, особливо
                  коли це потрібно вашому улюбленцю. Тому організовуємо доставку
                  максимально швидко.
                </p>
              </div>
            </div>
          </article>

          <article className={styles.benefitItem}>
            <div className={styles.benefitMedia}>
              <img
                src="https://dl.dropboxusercontent.com/scl/fi/8kxhzzm3xiin4lkr57shu/.png?rlkey=rbiul7f41wiz3myalog6kep7p&st=wxnebedd&dl=0"
                alt="Підтримка"
                loading="lazy"
              />
              <div className={styles.benefitGradient} />
              <div className={styles.benefitOverlay}>
                <h3>Підтримка</h3>
                <p>
                  Не знаєте, що обрати? Ми підкажемо! Допоможемо підібрати корм,
                  аксесуари та інші товари саме для вашого улюбленця.
                </p>
              </div>
            </div>
          </article>
        </div>
      </HomeSection>

      <HomeSection title="Корисні поради" className={styles.softBackground}>
        <div className={styles.tipList}>
          <article className={styles.tipItem}>
            <h3>Як обрати правильний корм?</h3>
            <p>
              Обирайте корм відповідно до віку, розміру та потреб вашого
              улюбленця. Наші експерти допоможуть знайти найкращий варіант.
            </p>
          </article>
          <article className={styles.tipItem}>
            <h3>Догляд за шерстю</h3>
            <p>
              Регулярне розчісування і використання спеціальних шампунів
              підтримує здоров&apos;я шерсті.
            </p>
          </article>
        </div>
      </HomeSection>

      <HomeSection title="Корисні поради для догляду за здоров'ям ваших улюбленців">
        <div className={styles.videoCategoryTabs}>
          {VIDEO_CATEGORIES.map((category) => (
            <button
              key={category}
              type="button"
              className={`${styles.videoCategoryTab} ${
                selectedCategory === category
                  ? styles.activeVideoCategoryTab
                  : ""
              }`}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>

        {currentVideo && (
          <div className={styles.videoCard}>
            <a
              href={currentVideo.url}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.videoPreviewLink}
              aria-label={`Відкрити відео: ${currentVideo.title}`}
            >
              <div className={styles.videoPreviewWrapper}>
                <img
                  src={currentVideo.thumbnail}
                  alt={currentVideo.title}
                  className={styles.videoPreviewImage}
                  loading="lazy"
                />
                <div className={styles.videoPreviewOverlay}>
                  <div className={styles.playButton}>▶</div>
                </div>
              </div>
            </a>

            <div className={styles.videoInfo}>
              <h3>{currentVideo.title}</h3>
              <p>
                Категорія: <strong>{currentVideo.category}</strong>
              </p>
            </div>

            <div className={styles.videoActions}>
              <a
                href={currentVideo.url}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.youtubeButton}
              >
                <FaYoutube className={styles.youtubeIcon} />
                <span>Дивитися на YouTube</span>
              </a>

              <button
                type="button"
                className={styles.nextVideoButton}
                onClick={showNextVideo}
              >
                <span>Показати інше відео</span>
                <LiaArrowRightSolid className={styles.nextVideoIcon} />
              </button>
            </div>
          </div>
        )}
      </HomeSection>

      {promotionsVisible && <PromoModal
        isOpen={isPromoOpen}
        onClose={closePromoModal}
        onPrimaryAction={() => {
          closePromoModal();
          navigate(PROMOTIONS_PATH);
        }}
      />}
    </div>
  );
}

export default Home;

